import { createUseStyles } from "react-jss";
import { colors } from "../../../styles/colors";
const useStyles = createUseStyles({
  divDepartement: {
    display: "flex",
    flexDirection: "column",
    borderRadius: "15px",
    padding: "15px",
    gap: "15px",
    backgroundColor: colors.surface,
    border: `1px solid ${colors.borderLight}`,
    height: "fit-content",
  },
  divButtonTVA: {
    display: "flex",
    flexDirection: "row",
    gap: "15px",
    alignItems: "flex-end",
    "& > div": {
      margin: 0,
      flex: 1,
      minWidth: 0,
    },
    "@media (max-width:599.95px)": {
      flexDirection: "column",
      alignItems: "stretch",
      gap: "10px",
    },
  },
  divListService: {
    display: "flex",
    flexDirection: "column",
    gap: "15px",
    padding: "15px",
  },
  serviceList: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },
  divServiceList: {
    display: "flex",
    flexDirection: "row",
    gap: "15px",
    flexWrap: "wrap",
  },
  divService: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    height: "30px",
    borderRadius: "50px",
    padding: "3px 10px 3px 15px",
    gap: "5px",
    backgroundColor: colors.default,
    transition: "background-color 0.15s ease",
    "&:hover": {
      backgroundColor: colors.surfaceHover,
    },
  },
  chipDeleteBtn: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    border: "none",
    background: "transparent",
    padding: 0,
    marginLeft: "2px",
    cursor: "pointer",
    borderRadius: "50%",
    width: "18px",
    height: "18px",
    transition: "background-color 0.15s ease, transform 0.15s ease",
    "&:hover": {
      backgroundColor: colors.errorLight,
      transform: "scale(1.1)",
    },
    "&:focus-visible": {
      outline: `2px solid ${colors.primary}`,
      outlineOffset: "1px",
    },
  },
  emptyState: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "20px",
    borderRadius: "12px",
    border: `1px dashed ${colors.borderLight}`,
    textAlign: "center",
    color: colors.mutedText,
  },
  skeletonChip: {
    height: "30px",
    width: "90px",
    borderRadius: "50px",
    backgroundColor: colors.surfaceHover,
    animation: "$pulse 1.2s ease-in-out infinite",
  },
  "@keyframes pulse": {
    "0%, 100%": { opacity: 0.5 },
    "50%": { opacity: 1 },
  },
});

export default useStyles;
